<!-- =========================================================================================
    File Name: ResendTokenEmail.vue
    Description: Resend Token Email Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img v-if="setResendTokenPageImage" :src="img_cdn + setResendTokenPageImage" alt="login" class="mx-auto">
            </div>


            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Resend Pin code!</h4>
                  <p class="mb-4">Enter your email to get email verfication pin code.</p>
                  <!--                  <p>Your are re.</p>-->
                </div>
                <div>

                  <vs-input
                    v-validate="'required|email'"
                    data-vv-validate-on="blur"
                    name="email"
                    icon-no-border
                    icon="icon icon-mail"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="userEmail"
                    class="w-full"/>
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                  <br>

                  <router-link to="/login">
                    <vs-button type="border">Cancel</vs-button>
                  </router-link>
                  <vs-button class="float-right" :disabled="!validateForm" @click="submitData">Submit</vs-button>
                  <br>
                </div>
              </div>
            </div>


          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {GET_IMAGE_SETTING, RESEND_TOKEN_EMAIL} from '@/graphql'


export default {
  data() {
    return {
      userEmail: '',
      img_cdn:process.env.VUE_APP_IMAGES_CDN_LINK,
      setResendTokenPageImage:''


    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.userEmail !== ''
    }
  },
  methods: {

    submitData() {
      this.$apollo
        .mutate({
          mutation: RESEND_TOKEN_EMAIL,
          variables: {
            email: this.userEmail,
          }
        })
        .then(response => {
          if (response.data.resendTokenEmail.status == 'SUCCESS') {
            localStorage.removeItem('userPinTime')
            this.SuccessStatus()
            localStorage.setItem('userPinTime', response.data.resendTokenEmail.pin_time)
            this.$router.replace('/verify-email')


          } else if (response.data.resendTokenEmail.status == 'ALREADY_APPROVED') {
            this.emailAlreadyApprovedNotification()

          }
        }).catch(error => {
        this.NotFoundNotification()
      });

    },
    SuccessStatus() {
      this.$vs.notify({
        title: "Email Sent",
        text: 'Email sent sucessfully check your email',
        color: 'success',
        position: 'top-right'
      })

    },
    emailAlreadyApprovedNotification() {
      this.$vs.notify({
        title: "Already Confirmed",
        text: 'Your Email Has Already Confirmed',
        color: 'danger',
        position: 'top-right'
      })
    },
    StatusInvalid() {

      this.$vs.notify({
        title: "Incorrect Data",
        text: 'Check and Enter again',
        color: 'danger',
        position: 'top-right'
      })
    },

    NotFoundNotification() {
      this.$vs.notify({
        title: "Not Found",
        text: 'User Not Found',
        color: 'danger',
        position: 'top-right'
      })
    },

  },
  beforeCreate() {
    this.$apollo
      .query({
        query: GET_IMAGE_SETTING,
      })
      .then(response => {
        if (response.data.getImagesSetting.resend_token_page_image != null) {
          this.setResendTokenPageImage = response.data.getImagesSetting.resend_token_page_image
        }
      })
      .catch(error => {
        console.log(error)
      });
  },

}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }
}
</style>
